"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPISODIC_EXPECTATIONS = exports.ANY_ADOPTING_STATE = void 0;
const window_1 = require("./window");
/**
 * ── Episodic generation, 40 CFR 262 subpart L ──────────────────────────────
 *
 * The provision's own hand-authored expectations — reviewed ONCE, here, rather
 * than restated in every jurisdiction's table. The same discipline as the
 * jurisdiction tables applies (see the vocabulary header in ../rules/types.ts):
 * a row changes only when a regulatory specialist says the law reads
 * differently, never to make the module below pass, and rows are never
 * regenerated from the implementation.
 *
 * These rows describe both the relief the regulation grants
 * (`getEpisodicRelief`) and the window the engine imposes (`episodicLimit`).
 */
/**
 * The state axis a claim constrains. `ADOPTING` stands for every state no row
 * names — and for a facility with no recorded state, which answers under
 * federal law.
 */
exports.ANY_ADOPTING_STATE = "ADOPTING";
/**
 * Cited federally on purpose. Nothing in a non-adopting state's own code
 * mentions subpart L — the provision that withholds it is the federal rule
 * saying an authorized state need not take up a less-stringent federal change.
 */
const NOT_ADOPTED = {
    kind: "NO_LIMIT",
    citation: "40 CFR 271.1(i)(2)",
    jurisdiction: "FEDERAL",
};
const NOT_ADOPTED_NOTE = "Episodic generation is relief added by the 2016 Generator Improvements Rule, and a " +
    "less-stringent federal provision does not take effect in an authorized state until that " +
    "state adopts it. A facility here may still declare an event as an EPA-notification record, " +
    "but its containers stay on the state's clocks, its waste stays under the on-site cap, and " +
    "the surge still counts toward its generator category. Unconfirmed by a regulatory " +
    "specialist; deliberately the more protective reading.";
exports.EPISODIC_EXPECTATIONS = [
    // ── States that have not adopted subpart L ─────────────────────────────
    {
        when: { state: "CA" },
        expect: { clock: NOT_ADOPTED },
        note: `California (DTSC) has not adopted 40 CFR 262 subpart L. ${NOT_ADOPTED_NOTE}`,
    },
    {
        when: { state: "CT" },
        expect: { clock: NOT_ADOPTED },
        note: "Connecticut (DEEP) has not adopted 40 CFR 262 subpart L: its program incorporates the " +
            `CFR as of July 1, 2000, predating the 2016 Generator Improvements Rule. ${NOT_ADOPTED_NOTE}`,
    },
    {
        when: { state: "MA" },
        expect: { clock: NOT_ADOPTED },
        note: "Massachusetts (MassDEP) has not adopted 40 CFR 262 subpart L: 310 CMR 30.000 carries no " +
            "episodic generation provision, so a generator that exceeds its category's quantity " +
            `limits moves up a category for that month. ${NOT_ADOPTED_NOTE}`,
    },
    {
        when: { state: "MN" },
        expect: { clock: NOT_ADOPTED },
        note: `Minnesota (MPCA) has not adopted 40 CFR 262 subpart L. ${NOT_ADOPTED_NOTE}`,
    },
    // ── Every state that did adopt it, whatever the facility's tier ────────
    {
        when: { state: exports.ANY_ADOPTING_STATE },
        expect: { clock: window_1.EPISODIC_WINDOW },
        note: "The surge waste must move within 60 days of the EVENT's start. 262.232(a)(4) gives a " +
            "VSQG's episodic waste the one central deadline it has, where 262.14 otherwise imposes " +
            "no clock at all; 262.232(b)(4) gives an SQG a deadline both shorter than its standing " +
            "180/270-day clock and dated from a different thing. The 200-mile extension is a " +
            "262.16(c) provision and does not reach episodic waste. The window holds at every tier: " +
            "an unresolved status with a declared event asserts VSQG/SQG standing, and an LQG's " +
            "standing 90-day clock outlasts the window, so honoring a declaration is never the less " +
            "protective answer. Unconfirmed by a regulatory specialist for an unresolved status.",
    },
];
//# sourceMappingURL=expectations.js.map